import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
@Component({
  selector: 'app-generic-modal',
  templateUrl: './generic-modal.component.html',
  styleUrls: ['./generic-modal.component.css'],
  animations: []
})
export class GenericModalComponent implements OnInit {

  constructor() { }

  @Input() title;

  @Output() emitClose = new EventEmitter();
  showContent = true;

  ngOnInit() {
    document.addEventListener('keyup', this.logKey.bind(this));
  }

  closeModal() {
    this.showContent = false;
    setTimeout(e => this.emitClose.emit(), 500);
  }

  logKey(e) {
    e.stopPropagation();
    if (e.keyCode === 27) {
      this.emitClose.emit();
    }
  }

}
